import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/embr/assets/images/twitter.svg'
import _imports_1 from '@/embr/assets/images/discord.svg'
import _imports_2 from '@/embr/assets/images/telegram.svg'
import _imports_3 from '@/embr/assets/images/medium.svg'


const _hoisted_1 = { class: "flex items-center px-4" }
const _hoisted_2 = { class: "ml-2" }
const _hoisted_3 = { class: "flex items-center px-4" }
const _hoisted_4 = { class: "px-4 text-right" }
const _hoisted_5 = { class: "flex items-center px-6" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: { width: '20px', 'max-width': '20px' }
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: { width: '20px', 'max-width': '20px' }
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: { width: '20px', 'max-width': '20px' }
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: { width: '20px', 'max-width': '20px' }
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]

import { computed, ref } from 'vue';
import useTokens from '@/composables/useTokens';
import BalTable, {
  ColumnDefinition
} from '@/components/_global/BalTable/BalTable.vue';
import BalCard from '@/components/_global/BalCard/BalCard.vue';
import BalAsset from '@/components/_global/BalAsset/BalAsset.vue';
import useNumbers from '@/composables/useNumbers';
import BalIcon from '@/components/_global/BalIcon/BalIcon.vue';
import { useRouter } from 'vue-router';
import useLgesQuery from '@/embr/lbp/composables/useLgesQuery';
import { GqlLge } from '@/embr/services/embr/embr-types';
import { watch } from 'vue';
import { formatDistanceToNow, parseISO, isBefore, isAfter } from 'date-fns';
import BalTabs from '@/components/_global/BalTabs/BalTabs.vue';
import { orderBy } from 'lodash';
import usePools from '@/composables/pools/usePools';


export default _defineComponent({
  setup(__props) {

const { tokens, loading, injectTokens } = useTokens();
const { fNum } = useNumbers();
const router = useRouter();

const { pools } = usePools();
const { data, isLoading, isIdle, isError } = useLgesQuery();

const tokenAddresses = computed(() => {
  return (data.value || []).map(lge => lge.tokenContractAddress);
});

const columns = ref<ColumnDefinition<GqlLge>[]>([
  {
    name: 'Project',
    id: 'name',
    accessor: 'name',
    width: 200
  },
  {
    name: 'Token',
    id: 'token',
    accessor: 'token',
    width: 200,
    Cell: 'tokenCell'
  },
  {
    name: 'Status',
    id: 'status',
    accessor: 'status',
    Cell: 'statusCell',
    sortKey: 'startDate',
    width: 200
  },
  /*{
    name: 'Volume',
    id: 'volume',
    accessor: 'volume',
    sortKey: 'volume',
    Cell: 'volumeCell',
    align: 'right',
    width: 125
  },*/
  {
    name: 'Links',
    id: 'links',
    accessor: 'links',
    Cell: 'linksCell',
    width: 125
  }
]);

function handleRowClick(lge: GqlLge) {
  router.push({ name: 'lge', params: { id: lge.id } });
}

watch(tokenAddresses, updated => {
  injectTokens(updated);
});

const tabs = [
  { value: 'active-upcoming', label: 'Active & Upcoming' },
  { value: 'previous', label: 'Previous' }
];

const activeTab = ref(tabs[0].value);

const visibleLges = computed(() => {
  const now = new Date();

  const lges = (data.value || []).filter(lge => {
    return activeTab.value === 'active-upcoming'
      ? isBefore(now, parseISO(lge.endDate))
      : isAfter(now, parseISO(lge.endDate));
  });

  lges.forEach(lge => {
    console.log(
      lge.id,
      pools.value?.find(pool => pool.id === lge.id)
    );
  });

  return activeTab.value === 'active-upcoming'
    ? orderBy(lges, 'startDate', 'asc')
    : orderBy(lges, 'endDate', 'desc');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BalTabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = $event)),
      tabs: tabs,
      "no-pad": "",
      class: "-mb-px"
    }, null, 8, ["modelValue"]),
    (!_unref(loading))
      ? (_openBlock(), _createBlock(BalCard, {
          key: 0,
          shadow: "lg",
          class: "mt-4",
          square: _ctx.upToLargeBreakpoint,
          noBorder: _ctx.upToLargeBreakpoint,
          noPad: ""
        }, {
          default: _withCtx(() => [
            _createVNode(BalTable, {
              "is-loading": _unref(isLoading),
              columns: columns.value,
              data: _unref(visibleLges),
              "skeleton-class": "h-64",
              sticky: "both",
              square: _ctx.upToLargeBreakpoint,
              isSortable: false,
              "is-paginated": false,
              isLoadingMore: false,
              "on-row-click": handleRowClick
            }, {
              tokenCell: _withCtx((auction) => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(BalAsset, {
                    address: auction.tokenContractAddress,
                    iconURI: auction.tokenIconUrl
                  }, null, 8, ["address", "iconURI"]),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(tokens)[auction.tokenContractAddress]?.symbol), 1)
                ])
              ]),
              statusCell: _withCtx((auction) => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: _normalizeClass([
              'w-3.5 h-3.5 rounded-full mr-2',
              _unref(isBefore)(new Date(), _unref(parseISO)(auction.startDate))
                ? 'bg-purple-500'
                : _unref(isAfter)(new Date(), _unref(parseISO)(auction.endDate))
                ? 'bg-gray-500'
                : 'bg-green-500'
            ])
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(_unref(isBefore)(new Date(), _unref(parseISO)(auction.startDate))
              ? `Starts in ${_unref(formatDistanceToNow)(_unref(parseISO)(auction.startDate))}`
              : _unref(isAfter)(new Date(), _unref(parseISO)(auction.endDate))
              ? `Ended ${_unref(formatDistanceToNow)(_unref(parseISO)(auction.endDate))} ago`
              : `Ends in ${_unref(formatDistanceToNow)(_unref(parseISO)(auction.endDate))}`), 1)
                ])
              ]),
              volumeCell: _withCtx((auction) => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(pools)?.find(pool => pool.id === auction.id)?.totalSwapVolume), 1)
              ]),
              linksCell: _withCtx((auction) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    href: auction.websiteUrl,
                    target: "_blank",
                    class: "mr-2"
                  }, [
                    _createVNode(BalIcon, { name: "globe" })
                  ], 8, _hoisted_6),
                  (auction.twitterUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: auction.twitterUrl,
                        target: "_blank",
                        class: "mr-2 -mt-1"
                      }, _hoisted_9, 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  (auction.discordUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: auction.discordUrl,
                        target: "_blank",
                        class: "-mt-1 mr-2"
                      }, _hoisted_12, 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (auction.telegramUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: auction.telegramUrl,
                        target: "_blank",
                        class: "-mt-1 mr-2"
                      }, _hoisted_15, 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  (auction.mediumUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        href: auction.mediumUrl,
                        target: "_blank",
                        class: "-mt-1 mr-2"
                      }, _hoisted_18, 8, _hoisted_16))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["is-loading", "columns", "data", "square"])
          ]),
          _: 1
        }, 8, ["square", "noBorder"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})